import { Translate } from '@dreryk/react-common';
import { IconSize, IconWrapper, QuestionmarkCircleIcon, Toggle, Tooltip } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../../../translations';
import { ReceptionServiceFormController } from '../../../ReceptionServiceForm';

type ReceptionServiceAdvancePaymentToggleFieldProps = Pick<ReceptionServiceFormController, 'register'>;

export const ReceptionServiceAdvancePaymentToggleField = (
   props: ReceptionServiceAdvancePaymentToggleFieldProps
): JSX.Element => {
   return (
      <Toggle
         testId={'advancePaymentChecked'}
         controller={props.register('advancePaymentChecked')}
         rightSlot={
            <>
               <Translate>
                  {receptionServiceTranslationKeys.shared.form.components.advancePaymentCheckedToggle.label}
               </Translate>
               <Tooltip
                  testId={'advancePaymentChecked'}
                  content={
                     receptionServiceTranslationKeys.shared.form.components.advancePaymentCheckedToggle.tooltipContent
                  }
               >
                  <IconWrapper testId={'toggleTooltipIconWrapper'} size={IconSize.SMALLEST}>
                     <QuestionmarkCircleIcon />
                  </IconWrapper>
               </Tooltip>
            </>
         }
      />
   );
};
